export default {
    methods: {
        makeSuccessToast(title) {
            if (title) {
                let message = this.createMessage(title);
                this.$toast.success(message);
            }
        },

        makeInfoToast(title) {
            if (title) {
                let message = this.createMessage(title);
                this.$toast.info(message);
            }
        },

        makeErrorToast(title, errors) {
            if (title || errors) {
                let message = this.createErrorMessage(title, errors);
                this.$toast.error(message);
            }
        },

        createMessage(title) {
            return `<h3>${title}</h3>`;
        },

        createErrorMessage(title, errors) {
            let message = '';

            if (title) {
                message += `<h3>${title}</h3>`;
            }

            if (errors) {
                let errorMessages = [];

                Object.keys(errors).forEach(errorKey => {
                    let errorMessage = `<p>${errors[errorKey]}</p>`;
                    errorMessages.push(errorMessage);
                })

                if (errorMessages.length) {
                    message += '<br/>' + errorMessages.join('<br/>');
                }
            }

            return message;
        }
    }
}